import type { MatchHandle } from 'types/matchHandle';

export const handle: MatchHandle = {};
